import React from 'react';
import { globalStateCTX } from '../../GlobalState/GlobalState';
import GaugeCard from './Gauge/GaugeCard';
import { KPIStatus } from '../KPIs/KPICard/KpiCard';
import { useNonce } from '../../Utils/hooks';
import { WorkOrderStatisticsReadView } from '../../GeneratedServices';
import { statisticsApi } from '../../Http/Http';
import { useTranslation } from 'react-i18next';
import { FilterValuesType } from '../../FiltersProvider/FiltersProvider';

interface Props {
  propertyId?: number;
  filterValues?: FilterValuesType;
}

const ErrorReportGauge: React.FC<Props> = (props) => {
  const { t } = useTranslation('common');

  const { handleHttpErrors } = React.useContext(globalStateCTX);

  const [errorReportStatistics, setErrorReportStatistics] = React.useState<WorkOrderStatisticsReadView>();
  const [status, setStatus] = React.useState<KPIStatus>(KPIStatus.Loading);
  const [shouldReload, reload] = useNonce();

  React.useEffect(() => {
    const abortController = new AbortController();
    const load = async () => {
      try {
        setStatus(KPIStatus.Loading);
        const { data } = await statisticsApi.statisticsResourceReadWorkOrderStatistics(
          {
            ...props.filterValues,
            propertyId: props.propertyId
          },
          {
            signal: abortController.signal
          }
        );

        setErrorReportStatistics(data);
        setStatus(KPIStatus.None);
      } catch (error) {
        handleHttpErrors(error) && setStatus(KPIStatus.LoadError);
      }
    };
    load();

    return () => abortController.abort();
  }, [props.filterValues, props.propertyId, handleHttpErrors, shouldReload]);

  return (
    <GaugeCard
      title={t('faultReports')}
      data={[
        {
          id: '1',
          value: errorReportStatistics?.overdue ?? 0,
          label: t('greaterThan30Days')
        },
        {
          id: '2',
          value: errorReportStatistics?.active ?? 0,
          label: t('active')
        },
        {
          id: '3',
          value: errorReportStatistics?.finished ?? 0,
          label: t('closed')
        }
      ]}
      status={status}
      retry={reload}
    />
  );
};

export default ErrorReportGauge;
